
import { path, static_img_url } from '../Variables'
import LazyImage from './LazyImage'
import { useNavigate } from 'react-router-dom'
import { ScrollToTop } from '../CodeEasier'


function NoConnection() {

  const navigate = useNavigate()

  return (
    <div className='handlers'>
      {/* <LazyHelmet>
        <title>No Connection ~ {app_name}</title>
      </LazyHelmet> */}

      
      <ScrollToTop/>
      <LazyImage src={`${static_img_url}/handlers/noconnection.webp`} alt={'Image'} />
      <div className='mt-4 mb-3'>Oops ! Can not connect with server, Please check your internet and try again.</div>
      <button className='primaryButton h7' onClick={()=>navigate(path.home)}>Home</button>
    </div>
  )
}

export default NoConnection